import { GridApiPro, gridFilterModelSelector, gridFilteredSortedRowIdsSelector } from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";
import { OrganizationReportRow } from "../../../../models";
import { StatisticsCard } from "src/components";

interface IProps {
  apiRef: React.MutableRefObject<GridApiPro | null>;
  isLoading: boolean;
  rows: OrganizationReportRow[] | undefined;
}

const OrganizationReportResultsSummary = (props: IProps) => {
  const [teamsCount, setTeamsCount] = useState(0);
  const [rolesCount, setRolesCount] = useState(0);
  const [peopleCount, setPeopleCount] = useState(0);

  useEffect(() => {
    return props.apiRef.current?.subscribeEvent("filteredRowsSet", () => {
      const filteredRowIds = gridFilteredSortedRowIdsSelector(props.apiRef);
      const filterModel = gridFilterModelSelector(props.apiRef);
      const filteredRows =
        filterModel.items.length === 0 || (filterModel.items.length === 1 && filterModel.items[0].field === "")
          ? (props.rows ?? [])
          : (props.rows?.filter((x) => filteredRowIds.includes(x.id as string)) ?? []);

      setTeamsCount(new Set(filteredRows.filter((x) => x.teamId !== undefined).map((x) => x.teamId)).size);
      setRolesCount(new Set(filteredRows.filter((x) => x.roleId !== undefined).map((x) => x.roleId)).size);
      setPeopleCount(new Set(filteredRows.map((x) => x.personId)).size);
    });
  }, [props.apiRef, props.rows]);

  return (
    <StatisticsCard
      isLoading={props.isLoading}
      data={[
        { title: "Teams", value: teamsCount },
        { title: "Roles", value: rolesCount },
        { title: "People", value: peopleCount },
      ]}
    />
  );
};

export { OrganizationReportResultsSummary };
